import GoalsExplore from "./index";

const GoalsExploreContainer = () => {
  return <GoalsExplore />;
};

export default GoalsExploreContainer;
